import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { SettingsService } from '../../services';
import { modalLarge } from '../../shared/modules/dialogOptions';
import { Type3CreateComponent } from './type3-create.component';
import { Type3ListComponent } from './type3-list.component';

@Component({
    selector: 'app-type3',
    templateUrl: './type3.component.html',
    styleUrls: ['./type3.component.scss', '../layout/layout.component.scss']
})
export class Type3Component extends BaseComponent implements OnInit {

    @ViewChild('type3List') type3List: Type3ListComponent;
    public SiteIdFromModal: number;
    public isAdminOrUserEditor: boolean;
    public isPreviewOn: boolean = false;
    public loanPreviewData: any;
    SiteId: number;
    public listCol = 'col-md-12';
    type1: string = "Type 1";
    type2: string = "Type 2";
    type3: string = "Type 3";
    constructor(
        public router: Router,
        private route: ActivatedRoute,
        private settingService: SettingsService,
        private modalService: NgbModal,
        public activeModal: NgbActiveModal,
        private location: Location) {
        super(router)
    }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            if (params) {
                const id = params['id'];
                if (id != undefined) {
                    this.SiteId = id;
                } else {
                    this.SiteId = this.SiteIdFromModal;
                }
            }
        });

        let currentUser = super.currentLoggedUser();
        this.type3List.siteId = this.SiteId;
        if (currentUser.role === 'admin') {
            this.isAdminOrUserEditor = true;
            this.type3List.isAdminOrUserEditor = true;

            this.type3List.loadDataById(currentUser.accountId, this.SiteId);
        }
        else if (currentUser.role === 'user') {
            this.isAdminOrUserEditor = false;
            this.type3List.isAdminOrUserEditor = false;

            this.type3List.loadDataById(currentUser.accountId, this.SiteId);
        }
        else if (currentUser.role === 'superadmin') {
            this.type3List.isSuperAdmin = true;
            let secondaryUserData = super.secondaryAdminUser();
            if (secondaryUserData) {
                this.type3List.loadDataById(secondaryUserData.AccountId, this.SiteId);
            }
        }

        this.loadSetting();
    }

    loadSetting() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));

        this.settingService.getValue("type1", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type1 = response.Data.Value;
                }
            });


        this.settingService.getValue("type2", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type2 = response.Data.Value;
                }
            });

        if (localStorage.getItem('currentSiteId') != null) {
            this.SiteId = +localStorage.getItem('currentSiteId');
            //alert(this.SiteId);
        }

        this.settingService.getValue("type3", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type3 = response.Data.Value;
                }
            });
    }

    public openCreateType1(type: string): void {
        //var data = new Type3Component();            
        const modalRef = this.modalService.open(Type3CreateComponent, modalLarge);

        modalRef.result.then((result) => {
            this.ngOnInit();
            //this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.ngOnInit();
            //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
        //modalRef.componentInstance.SiteIdFromModal = this.SiteId;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/type3/type3.component.ts